import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';

import { AppActions } from '../actions/app';
//import { intl } from './intl';

const appActions = getActionIds(AppActions);

const initialState = Immutable.fromJS({
  isIE: false,
});

export const browser = createStore(initialState, {
  [appActions.setIEBool]: (state, action) => {
    return state.merge({
      isIE: action.bool,
    });
  },
});


// WEBPACK FOOTER //
// ./src/reducers/browser.js